import { HashRouter, Routes, Route } from 'react-router-dom';
import Konfigurator from './pages/Konfigurator';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Konfigurator />} />
      </Routes>
    </HashRouter>
  );
}
